import { Typography } from "@mui/material";
import copy from "copy-to-clipboard";

/**
 * Célula de código do informe (grupo, código do bem, CNPJ da fonte pagadora).
 * Mesma mecânica de copiar do `CelulaTexto`, mas em mono tabular: código e
 * CNPJ são dado, não texto corrido — e é assim que eles alinham coluna abaixo
 * na hora de conferir com o programa da Receita.
 * Ver DESIGN.md → Assinaturas da marca.
 */
export default function CelulaCodigo({
  codigo,
  copyOnClick = false,
}: {
  codigo?: string;
  copyOnClick?: boolean;
}): JSX.Element {
  return (
    <Typography
      variant="dataMono"
      onClick={
        copyOnClick
          ? (e) => copy((e.target as HTMLElement).innerText)
          : undefined
      }
      noWrap
      sx={[copyOnClick && { cursor: "pointer" }]}
    >
      {codigo}
    </Typography>
  );
}
